import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { TabsetComponent } from 'ngx-bootstrap/tabs';

import { Group } from '../../../Models/group';
import { Profile } from '../../../Models/profile';
import { User } from '../../../Models/user';
import { AdminService } from '../../../services/admin.service';
import { GenericModalService } from '../../../services/generic-modal.service';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

declare var $: any;


@Component({
  selector: 'app-group-modal',
  templateUrl: './group-modal.component.html',
  styleUrls: ['./group-modal.component.css', '../../../styles/modals.css']
})

export class GroupModalComponent implements OnInit {

  @Input() modalTitle: string;

  itemSaved: Subject<boolean>;

  availableUsers: User[];
  dmSelectedUsers = [];
  selectedUsers = [];
  availableProfiles: Observable<Profile[]>;

  groupForm: FormGroup;
  objId: number;
  submitted = false;
  submitClick = false;
  oldGroupData: Group;
  oldGroupUsers: User[];
  groupParam: GroupParam;
  error = '';
  initialGroupEnabledStatus: boolean;

  get formData() { return this.groupForm.controls; }

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private admService: AdminService,
    private modalService: GenericModalService
  ) { }

  ngOnInit() {
    this.admService.loadUserList()
      .subscribe(result => { this.availableUsers = result
        .filter((user) => {
          return user.enabled;
        });

        if (this.objId !== 0) {
          this.onEditGroup();
        }
        }, error => {
          let err = error;
          if (error.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.error = err;
          console.error(err);
      }
      );
    this.createForm();
    this.availableProfiles = this.admService.loadProfiles();
    this.itemSaved = new Subject();
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  onSave() {
    const group = this.groupForm.getRawValue();

    group.users = this.availableUsers.filter(item => {
      return (this.selectedUsers.indexOf(item.userId) > -1);
    });

    if (this.objId !== 0) {
      this.oldGroupData.users = this.oldGroupUsers;
    }

    this.groupParam = {
      groupId: this.objId,
      group: group,
      oldGroup: this.oldGroupData
    };

    this.submitted = false;
    this.error = '';
    this.submitClick = true;

    if (this.isDeactivation()) {
      this.admService.countGroupRelatedBPInstances(this.objId)
        .subscribe( count => {
          // Se não existe nenhuma instância alocada para o grupo, salva o grupo direto
          if (count === 0) {
            this.saveGroup();
            // Se existe, então exibe o modal de confirmação
          } else {
            let alert: any;
            alert = this.modalService
              .showConfirmModal('Inativação de grupo',
                'Instâncias associadas ao grupo permanecerão inacessíveis na fila de interação humana. Deseja continuar?'
              );

            alert.then((result) => {
              if (result.value)  {
                this.saveGroup();
              } else {
                this.submitClick = false;
              }
            });
          }
        }, error1 => {
          this.error += 'Não foi possível determinar se o grupo está vinculado a instâncias de processos de negócio. ';
          this.error += 'Evite salvar as alterações nesta tela enquanto este problema continuar a acontecer. ';
          this.error += error1;
          if (error1.toString().indexOf('Unauthorized') > -1) {
            this.error = 'Falha de autenticação. Realize o login novamente.';
            this.onClose();
          }
          this.submitClick = false;
        });
    } else {
      this.saveGroup();
    }
  }

  saveGroup() {
    this.error = '';
    this.admService.saveGroup(this.groupParam)
      .pipe(take(1))
      .subscribe(resp => {
          this.submitted = true;
          this.itemSaved.next(true);
          setTimeout(() => { this.submitted = false; this.bsModalRef.hide(); }, 2000);
        },
        error => {
          let err = error;
          if (error.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.error = err;
          this.submitClick = false;
        });
  }

  createForm() {
    this.groupForm = this.formBuilder.group({
      groupId: { value: 0, disabled: true },
      name: [ '', Validators.compose( [ Validators.required, Validators.maxLength(100) ]) ],
      profileId: [0, this.validateProfile],
      enabled: [true],
      isLdap: [false],
      description: [ '', Validators.maxLength(300)],
      users: [
        []
      ]
    });
  }

  onEditGroup() {
    this.error = '';
    this.admService.loadGroupById(this.objId)
      .subscribe(result => {
        if (result) {
          this.groupForm.patchValue({
            groupId: result.groupId,
            name: result.name,
            description: result.description,
            profileId: result.profileId,
            enabled: result.enabled,
            isLdap: result.isLdap
          });
          this.initialGroupEnabledStatus = result.enabled;
          this.oldGroupData = Object.assign({}, result) as Group;
        }
      }, error1 => this.error = error1);

    this.admService.loadGroupUsers(this.objId)
      .subscribe(result => {
        if (result) {
          this.dmSelectedUsers = result.map(m => m.userId);
          this.selectedUsers = this.dmSelectedUsers;
          this.oldGroupUsers = result;
        }
      }, error1 => this.error = error1);
  }

  validateProfile(input: FormControl) {
    return input.value === 0 ? { emptyProfile: true } : null;
  }

  isDeactivation() {
    // Se o grupo já iniciou inativo, retorno falso pois não é uma desativação
    if (!this.initialGroupEnabledStatus) {
      return false;
    }
    // Se o grupo não iniciou inativo, quer dizer que ele iniciou ativo
    // Se ele iniciou ativo e agora o checkbox = false : retorno verdadeiro (is a deactivation)
    // Se ele iniciou ativo e agora o chechbox = true : retorno falso (is not a deactivation)
    return !this.groupForm.controls.enabled.value;
  }

  onSelectAll(availableItems: any[], path: string, formGroup: FormGroup) {
    const selected = availableItems.map(item => item.userId);
    formGroup.get(path).patchValue(selected);
  }

  onClearAll(path: string, formGroup: FormGroup) {
    formGroup.get(path).patchValue([]);
  }

  getSelectedUsers(element) {
    this.selectedUsers = element;
  }

}

export class GroupParam {
  groupId: number;
  group: Group;
  oldGroup: Group;
}
